import { AD_UNIT_IDS } from '@/constants/ad';

import type { NativeAdSlotConfig as AdSlotConfig } from './NativeAdSlot';

//* 검색 결과 슬롯은 위치 규칙이 얽혀 있어 searchAdPlacements.ts에서 별도 관리한다.
export const AD_PLACEMENTS = {
  homeFeedBanner: {
    unitIdM: AD_UNIT_IDS.HOME_FEED_LIST_BANNER_M,
    unitIdP: AD_UNIT_IDS.HOME_FEED_LIST_BANNER_P,
    mWidth: 320,
    mHeight: 50,
    pWidth: 300,
    pHeight: 250,
  },
  homeFeedNative: {
    unitIdM: AD_UNIT_IDS.HOME_FEED_NATIVE_M,
    unitIdP: AD_UNIT_IDS.HOME_FEED_NATIVE_P,
    //* 피드 카드형 — 표준 백필 규격 밖, 직광고 전용 (백필 OFF)
    mWidth: 375,
    mHeight: 590,
    pWidth: 600,
    pHeight: 780,
  },
  //* 홈·혜택·정책 등 DesktopPageShell 우측 레일에서 공용으로 사용하는 글로벌 지면
  globalSide: {
    unitIdM: '', //* PC 전용 (모바일 우측 없음) — 모바일에서 PC 유닛 로드 방지
    unitIdP: AD_UNIT_IDS.GLOBAL_SIDE_P,
    mWidth: 250,
    mHeight: 250,
    pWidth: 300,
    pHeight: 250,
  },

  //* 친구초대 모바일 인라인 — PC는 우측 레일(globalSide)이 맡는다
  inviteMobileBanner: {
    unitIdM: AD_UNIT_IDS.INVITE_MIDDLE_M,
    unitIdP: '',
    mWidth: 320,
    mHeight: 100,
    pWidth: 300,
    pHeight: 250,
  },

  searchTopBanner: {
    unitIdM: AD_UNIT_IDS.SEARCH_TOP_M,
    unitIdP: AD_UNIT_IDS.SEARCH_TOP_P,
    mWidth: 320,
    mHeight: 100,
    pWidth: 728,
    pHeight: 90,
  },
  searchSide: {
    unitIdM: '', //* PC 전용 (모바일 우측 없음) — 모바일에서 PC 유닛 로드 방지
    unitIdP: AD_UNIT_IDS.SEARCH_SIDE_P,
    mWidth: 250,
    mHeight: 250,
    pWidth: 300,
    pHeight: 250,
  },

  policyGuideTop: {
    unitIdM: AD_UNIT_IDS.POLICY_GUIDE_TOP_M,
    unitIdP: '', //* PC는 콘솔 ID 미발급 — 발급 시 채우면 자동 활성
    mWidth: 320,
    mHeight: 100,
    pWidth: 300,
    pHeight: 250,
  },
  policyGuideBottom: {
    unitIdM: AD_UNIT_IDS.POLICY_GUIDE_BOTTOM_M,
    unitIdP: AD_UNIT_IDS.POLICY_GUIDE_BOTTOM_P,
    mWidth: 300,
    mHeight: 250,
    pWidth: 300,
    pHeight: 250,
  },
  policyGuideSide: {
    unitIdM: '', //* PC 전용 (모바일 우측 없음) — 모바일에서 PC 유닛 로드 방지
    unitIdP: AD_UNIT_IDS.POLICY_GUIDE_SIDE_P,
    mWidth: 250,
    mHeight: 250,
    pWidth: 300,
    pHeight: 250,
  },

  //* 혜택 본문 광고 — 모바일·PC는 위치별 유닛을 분리해 성과를 측정한다.
  benefitHomeTopNative: {
    unitIdM: AD_UNIT_IDS.BENEFIT_HOME_TOP_NATIVE_M,
    unitIdP: '',
    mWidth: 300,
    mHeight: 250,
    pWidth: 300,
    pHeight: 250,
  },
  benefitHomeMiddleNative: {
    unitIdM: AD_UNIT_IDS.BENEFIT_HOME_MIDDLE_NATIVE_M,
    unitIdP: AD_UNIT_IDS.BENEFIT_HOME_MIDDLE_NATIVE_P,
    mWidth: 300,
    mHeight: 250,
    pWidth: 300,
    pHeight: 250,
  },

  //* 웰로 키워드 펼침 패널 목록 중간 — 패널 가용 폭(모바일 358 · PC 328)에 들어가는 Adrop 백필 입찰풀 규격은 320×50뿐이다.
  trendKeywordRank5: {
    unitIdM: AD_UNIT_IDS.TREND_KEYWORD_RANK5_M,
    unitIdP: AD_UNIT_IDS.TREND_KEYWORD_RANK5_P,
    mWidth: 320,
    mHeight: 50,
    pWidth: 320,
    pHeight: 50,
  },
  trendKeywordRank10: {
    unitIdM: AD_UNIT_IDS.TREND_KEYWORD_RANK10_M,
    unitIdP: AD_UNIT_IDS.TREND_KEYWORD_RANK10_P,
    mWidth: 320,
    mHeight: 50,
    pWidth: 320,
    pHeight: 50,
  },
} as const satisfies Record<string, AdSlotConfig>;
